<div class="container">
  <div class="row">
    <div class="col-main col-lg-4 col-sm-6 mr-auto ml-auto">
      <div class="card card-register">
        <h3 class="title">{{title|traduccion}}</h3>
        <form class="register-form" [formGroup]="form" (ngSubmit)="submitForm()">

          <div *ngIf="mode=='reset'">
            <label>{{'email'|traduccion}}</label>
            <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus===true}">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="nc-icon nc-email-85"></i>
                </span>
              </div>

              <input formControlName="email" id="name" name="email" type="text" class="form-control" placeholder="{{'email'|traduccion}}"
                (focus)="focus=true" (blur)="focus=false">
            </div>
            <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
              <small *ngIf="email.errors.required">{{'email.errors.required'|traduccion}}<br></small>
              <small *ngIf="email.errors.email">{{'email.errors.email'|traduccion}}<br></small>
            </div>
          </div>

          <div *ngIf="mode=='change'">                
            <label>{{'password'|traduccion}}</label>
            <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="nc-icon nc-key-25"></i>
                </span>
              </div>
              <input formControlName="newPassword" name="newPassword" type="password" class="form-control" placeholder="{{'password'|traduccion}}"
                (focus)="focus1=true" (blur)="focus1=false">
            </div>

                      <!-- Barra visual -->
            <div *ngIf="passwordStrength > 0" class="strength-bar">
              <div
                class="strength"
                [ngClass]="{
                  'weak': passwordStrength <= 2,
                  'medium': passwordStrength === 3 || passwordStrength === 4,
                  'strong': passwordStrength === 5
                }"
                [style.width.%]="passwordStrength * 20">
              </div>
            </div>
          
            <p *ngIf="passwordStrength > 0" class="mt-1">
              Fortaleza:
              <span class="badge" [ngClass]="{
                'badge-danger': passwordStrength <= 2,
                'badge-warning': passwordStrength === 3 || passwordStrength === 4,
                'badge-success': passwordStrength === 5
              }">
                {{ passwordStrength <= 2 ? 'Débil' : passwordStrength < 5 ? 'Media' : 'Fuerte' }}
              </span>
            </p>

            <!-- Mensajes detallados -->
            <div *ngIf="newPassword?.touched && newPassword?.invalid" class="text-danger">
              <small *ngIf="newPassword.errors.required">{{'password.errors.required'|traduccion}}<br></small>
              <small *ngIf="newPassword?.errors?.['minLength']">{{'password.errors.minlength'|traduccion}}<br></small>
              <small *ngIf="newPassword?.errors?.['missingLowercase']">{{'password.errors.missingLowercase'|traduccion}}<br></small>
              <small *ngIf="newPassword?.errors?.['missingUppercase']">{{'password.errors.missingUppercase'|traduccion}}<br></small>
              <small *ngIf="newPassword?.errors?.['missingDigit']">{{'password.errors.missingDigit'|traduccion}}<br></small>
              <small *ngIf="newPassword?.errors?.['missingSpecial']">{{'password.errors.missingSpecial'|traduccion}}<br></small>
            </div>

            <label>{{'passwordConfirm'|traduccion}}</label>
            <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="nc-icon nc-key-25"></i>
                </span>
              </div>
              <input formControlName="passwordConfirm" name="passwordConfirm" type="password" class="form-control" placeholder="{{'passwordConfirm'|traduccion}}"
                (focus)="focus1=true" (blur)="focus1=false">
            </div>
            <div *ngIf="form.hasError('passwordMismatch') && form.get('passwordConfirm')?.touched" class="text-danger">
              <small>{{'password.errors.passwordNotMatch'|traduccion}}</small>
            </div>
          </div>
          <button [disabled]="!form.valid || sent" class="btn btn-outline-neutral btn-block btn-round">{{'reset_password'|traduccion}}</button>
        </form>
        <div class="forgot">
          <a (click)="_goTo('signin')" class="btn btn-link btn-terciary">{{'signin'|traduccion}}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer register-footer text-center">

  </div>
</div>